import { compareRows } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function CompareList() {
  return (
    <section id="compare" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          index="03"
          kicker="特征对比"
          title="钓鱼站特征 VS 官方特征"
          desc="下面 6 组差异，是从读者反馈中整理出的高频踩坑点。左边是钓鱼网站常见的样子，右边才是官方应有的样子，逐行比对即可。"
        />

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden grid-cols-[1fr_1.4fr_1.4fr] border-b border-background-200 bg-background-100 md:grid">
            <div className="px-6 py-4 text-xs font-semibold tracking-[0.18em] text-foreground-600">对比项</div>
            <div className="flex items-center gap-2 border-l border-background-200 px-6 py-4 text-xs font-semibold tracking-[0.18em] text-primary-700">
              <i className="ri-close-circle-line" />
              钓鱼站特征
            </div>
            <div className="flex items-center gap-2 border-l border-background-200 px-6 py-4 text-xs font-semibold tracking-[0.18em] text-accent-700">
              <i className="ri-checkbox-circle-line" />
              官方特征
            </div>
          </div>

          <ul className="divide-y divide-background-200">
            {compareRows.map((row) => (
              <li key={row.topic} className="grid grid-cols-1 md:grid-cols-[1fr_1.4fr_1.4fr]">
                <div className="flex items-center gap-2 bg-background-100/60 px-6 py-4 md:py-5">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-500 md:hidden" />
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{row.topic}</span>
                </div>
                <div className="border-t border-background-100 px-6 py-4 md:border-l md:border-t-0 md:py-5">
                  <span className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold text-primary-600 md:hidden">
                    <i className="ri-close-circle-line" />
                    钓鱼站
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{row.fake}</span>
                </div>
                <div className="border-t border-background-100 bg-accent-50/60 px-6 py-4 md:border-l md:border-t-0 md:py-5">
                  <span className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold text-accent-700 md:hidden">
                    <i className="ri-checkbox-circle-line" />
                    官方
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-800">{row.real}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}